import { UPDATE_TESTIMONIAL_REDUCER } from "store/actionTypes";
import { ActionType, TestimonialReducerModal } from "utils/modals";

export const TestimonialReducer = (
  state: TestimonialReducerModal = new TestimonialReducerModal(),
  action: ActionType
) => {
  switch (action.type) {
    case UPDATE_TESTIMONIAL_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default TestimonialReducer;
